import Image from 'next/image'

import SectionTitle from '@/components/SectionTitle'
import env from '@/lib/env'
import { mq } from '@/styles/size'

const IMAGES = [
  {
    src: `${env.BASE_PATH}/static/images/certified/iso-logo.svg`,
    alt: 'iso',
  },
]

function Certified(): React.ReactElement {
  return (
    <section
      css={(theme) =>
        mq({
          paddingTop: ['60px', '60px', '120px'],
          padditBottom: 0,
          width: theme.size.width[90],
          maxWidth: theme.size.width[900],
          height: 'auto',
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          flexFlow: 'column nowrap',
          margin: 'auto',
          position: 'relative',
        })
      }
    >
      <SectionTitle>Certified</SectionTitle>
      <div
        className="image-block"
        css={mq({
          display: 'grid',
          gridTemplateColumns: '1fr',
          maxWidth: ['320px', '400px', '600px', '1000px'],
          marginTop: '32px',
          gridGap: '32px',
        })}
      >
        {IMAGES.map((image, index) => {
          return (
            <div
              key={`${index}`}
              className="image-block"
              css={mq({
                display: 'grid',
                width: ['209px', '209px', '230px'],
                height: ['80px', '80px', '88px'],
                marginTop: '32px',
                gridGap: '32px',
              })}
            >
              <Image
                src={image.src}
                alt={image.alt}
                width="230px"
                height="88px"
                objectFit="contain"
                layout="responsive"
              />
            </div>
          )
        })}
      </div>
      <p
        css={(theme) =>
          mq({
            fontSize: '16px',
            textAlign: 'center',
            fontWeight: 300,
            marginTop: '40px',
            color: theme.colors.secondary[1000],
          })
        }
      >
        PDPA Prokit ได้รับมาตรฐาน{' '}
        <strong
          css={(theme) => ({
            fontWeight: 500,
            color: theme.colors.primary[400],
          })}
        >
          ISO&nbsp;27001 (Information&nbsp;Security)
        </strong>{' '}
        <br
          css={mq({
            display: ['none', 'none', 'none', 'block'],
          })}
        />
        และมาตรฐาน{' '}
        <strong
          css={(theme) => ({
            fontWeight: 500,
            color: theme.colors.primary[400],
          })}
        >
          ISO&nbsp;27701 (Privacy&nbsp;Information)
        </strong>{' '}
      </p>
    </section>
  )
}

export default Certified
